import { dutchOrderPlatesActions, dutchOrderPlatesStore } from ".."

export function resetStore() {
    dutchOrderPlatesActions.resetData()
}

export function hydrateWorktaskSwitch(hydrate: boolean) {
    dutchOrderPlatesStore.setState({ hydrateWorktaskSwitch: hydrate }, false, "Hydrate worktask switch")
}

export function setWorktaskId(worktaskId: string) {
    dutchOrderPlatesStore.setState(
        {
            worktaskId,
        },
        false,
        "Set worktask Id"
    )
}
